A work type code for the `seekAnz` scheme.

Currently, four codes are defined:

- `Casual` indicates a casual position.
- `ContractTemp` indicates a fixed-length contract position.
- `FullTime` indicates a full-time position.
- `PartTime` indicates a part-time position.

For positions in other schemes this will be `null`.
